'use strict';

module.exports = {
    'dietTimimgs': {
        dots: true,
        infinite: false,
        arrows: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 2,
        prevArrow: '<span class="slick-prev"><i class="icon-arrow-angle-left d-lg-none"></i><i class="icon-arrow-left d-none d-lg-block"></i></span>',
        nextArrow: '<span class="slick-next"><i class="icon-arrow-angle-right d-lg-none"></i><i class="icon-arrow-right d-none d-lg-block"></i></span>',
        responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
        ]
    },
    'dietReviews': {
        dots: true,
        infinite: false,
        arrows: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        prevArrow: '<span class="slick-prev"><i class="icon-arrow-left"></i></span>',
        nextArrow: '<span class="slick-next"><i class="icon-arrow-right"></i></span>'
    },
    'dietNav': {
        dots: false,
        infinite: false,
        arrows: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '<span class="slick-prev"><i class="icon-arrow-left"></i></span>',
        nextArrow: '<span class="slick-next"><i class="icon-arrow-right"></i></span>',
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
                breakpoint: 580,
                settings: {
                  slidesToShow: 2.5
                }
            },
            {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1.5
                }
            }
        ]
    }
};
